import type { PromoCode, PromoCodeDto } from '~/modules/promocodes/model'
import { insertPropsIf } from '~/common'

export const convertToPromoCodeDto = (
  { number, key, ...promoCode }: PromoCode,
  generatePromocodes: boolean
): PromoCodeDto => ({
  ...promoCode,
  discountOnShippingCosts: promoCode.discountOnShippingCosts / 100,
  ...insertPropsIf(!generatePromocodes, { key }),
  ...insertPropsIf(generatePromocodes, { number }),
})
